import { Component } from '@ribajs/core'
import { isInMarketAllowlist, redirectToPath } from '../utils'

export class SbBlogArticleComponent extends Component {
  public static tagName = 'sb-blog-article'

  public scope = {
    /**
     * Array of allowed markets
     */
    allowedMarkets: [] as string[],
    /**
     * Is the article a detail view
     */
    isDetail: false,
  }

  static get observedAttributes(): string[] {
    return ['allowed-markets', 'is-detail']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbBlogArticleComponent.observedAttributes)
  }

  async beforeBind() {
    // Redirect to 404 / remove the article if the current market is not in the allowlist
    if (!isInMarketAllowlist(this.scope.allowedMarkets)) {
      this.remove()
      if (this.scope.isDetail) {
        redirectToPath('404')
      }
    }
    await super.beforeBind()
  }

  protected template() {
    return null
  }
}
